import React, {useState, useEffect} from 'react';
import {withTranslation} from 'react-i18next';
import {Form, Field} from 'react-final-form';
import {classNames} from 'primereact/utils';
import {InputText} from 'primereact/inputtext';
import {Button} from 'primereact/button';
import {PickList} from 'primereact/picklist';
import {Panel} from "primereact/panel";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Dropdown} from "primereact/dropdown";

import EntryzoneFormService from '../../services/entryzone/EntryzoneFormService'
import EntrylocationListService from "../../services/entrylocation/EntrylocationListService";
import EntryzoneWorktypeAddService from "../../services/entryzone/EntryzoneWorktypeAddService";
import EntryzoneWorktypeListService from "../../services/entryzone/EntryzoneWorktypeListService";
import EntryzoneWorktypeRemoveService from "../../services/entryzone/EntryzoneWorktypeRemoveService";
import EntryzoneAttachableWorktypeListService from "../../services/entryzone/EntryzoneAttachableWorktypeListService";
import {AutoComplete} from "primereact/autocomplete";
import PartnerListService from "../../services/partner/PartnerListService";

const EntryzoneFormComponent = (props) => {

  const [formData, setFormData] = useState({
    entryLocation: {id: Number(localStorage.getItem('defaultProjectId'))},
  });
  const [loading, setLoading] = useState(false);

  const validate = (data) => {
    let errors = {};
    // if (!data.name) {
    //   errors.name = 'Az megnevezés nem lehet üres';
    // }
    // if (!data.entryLocation) {
    //   errors.entryLocation = 'A projekt nem lehet üres';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    setFormData({
      ...formData,
      data
    });
    if ((props && props.initialValues) || formData.id) {
      EntryzoneFormService(data, 'put')
        .then(response => {
          window.App.toastShow('success', 'Sikeres módosítás!');
          loadLazyDataWorktypesSource(response.data.id);
          loadLazyDataWorktypesTarget(response.data.id);
          window.App.setState({rerenderEntryzoneList: true})
          if (props.closeForm === true) {
            window.App.setState({
              sidebarEntryzoneUpdate: false,
              sidebarEntryzoneCreate: false
            })
          }
          setLoading(false)
        })
        .catch(error => {
          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
          setLoading(false)
        })
    } else {
      EntryzoneFormService(data, 'post')
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          setFormData(response.data)
          loadLazyDataWorktypesSource(response.data.id);
          loadLazyDataWorktypesTarget(response.data.id);
          window.App.setState({rerenderEntryzoneList: true})
          if (props.closeForm === true) {
            window.App.setState({
              sidebarEntryzoneCreate: false
            })
          }
          setLoading(false)
        })
        .catch(error => {
          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
          setLoading(false)
        })
    }
    form.restart();
  };
  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  // worktypes assign
  const [worktypesSource, setWorktypesSource] = useState([]);
  const [worktypesToAdd, setWorktypesToAdd] = useState([]);
  const [worktypesTarget, setWorktypesTarget] = useState([]);
  const [worktypesToDelete, setWorktypesToDelete] = useState([]);

  const [loadingWorktypesSource, setLoadingWorktypesSource] = useState(false);
  const [totalRecordsWorktypesSource, setTotalRecordsWorktypesSource] = useState(0);
  const [rowsWorktypesSource, setRowsWorktypesSource] = useState(10);
  const [lazyParamsWorktypesSource, setLazyParamsWorktypesSource] = useState({
    first: 0,
    rows: rowsWorktypesSource,
    page: 0,
    sortField: 'id',
    sortOrder: -1
  });
  let loadLazyTimeoutWorktypesSource = null;
  const loadLazyDataWorktypesSource = (entryzoneId) => {
    setLoadingWorktypesSource(true);
    if (loadLazyTimeoutWorktypesSource) {
      clearTimeout(loadLazyTimeoutWorktypesSource);
    }
    loadLazyTimeoutWorktypesSource = setTimeout(() => {
      EntryzoneAttachableWorktypeListService(JSON.stringify(lazyParamsWorktypesSource), entryzoneId)
        .then(response => {
          setTotalRecordsWorktypesSource(response.data.total_item_count);
          setWorktypesSource(response.data.items);
          setLoadingWorktypesSource(false);
        })
        .catch(error => {
          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPageWorktypesSource = (event) => {
    let _lazyParams = {...lazyParamsWorktypesSource, ...event};
    setLazyParamsWorktypesSource(_lazyParams);
  }
  const onSortWorktypesSource = (event) => {
    let _lazyParams = {...lazyParamsWorktypesSource, ...event};
    setLazyParamsWorktypesSource(_lazyParams);
  }
  const onFilterWorktypesSource = (event) => {
    let _lazyParams = {...lazyParamsWorktypesSource, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParamsWorktypesSource(_lazyParams);
  }
  const pagerWorktypesSource = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: 10, value: 10},
        {label: 20, value: 20},
        {label: 50, value: 50},
        {label: 200, value: 200}
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions}
                    onChange={(e) => setRowsWorktypesSource(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };
  const onWorktypesSubmit = () => {
    let _worktypesToAdd = []
    Object.entries(worktypesToAdd).map(function (worktype, index) {
      _worktypesToAdd.push(worktype[1].id)
    })
    EntryzoneWorktypeAddService(_worktypesToAdd, formData.id)
      .then(response => {
        window.App.toastShow('success', 'Sikeres mentés!');
        loadLazyDataWorktypesSource(formData.id);
        loadLazyDataWorktypesTarget(formData.id);
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
      })
  }

  const [loadingWorktypesTarget, setLoadingWorktypesTarget] = useState(false);
  const [totalRecordsWorktypesTarget, setTotalRecordsWorktypesTarget] = useState(0);
  const [rowsWorktypesTarget, setRowsWorktypesTarget] = useState(10);
  const [lazyParamsWorktypesTarget, setLazyParamsWorktypesTarget] = useState({
    first: 0,
    rows: rowsWorktypesTarget,
    page: 0,
    sortField: 'id',
    sortOrder: -1
  });
  let loadLazyTimeoutWorktypesTarget = null;
  const loadLazyDataWorktypesTarget = (entryzoneId) => {
    setLoadingWorktypesTarget(true);
    if (loadLazyTimeoutWorktypesTarget) {
      clearTimeout(loadLazyTimeoutWorktypesTarget);
    }
    loadLazyTimeoutWorktypesTarget = setTimeout(() => {
      EntryzoneWorktypeListService(JSON.stringify(lazyParamsWorktypesTarget), entryzoneId)
        .then(response => {
          setTotalRecordsWorktypesTarget(response.data.total_item_count);
          setWorktypesTarget(response.data.items);
          setLoadingWorktypesTarget(false);
        })
        .catch(error => {
          window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
        })
    }, Math.random() * 1000 + 250);
  }
  const onPageWorktypesTarget = (event) => {
    let _lazyParams = {...lazyParamsWorktypesTarget, ...event};
    setLazyParamsWorktypesTarget(_lazyParams);
  }
  const onSortWorktypesTarget = (event) => {
    let _lazyParams = {...lazyParamsWorktypesTarget, ...event};
    setLazyParamsWorktypesTarget(_lazyParams);
  }
  const onFilterWorktypesTarget = (event) => {
    let _lazyParams = {...lazyParamsWorktypesTarget, ...event};
    _lazyParams['first'] = 0;
    _lazyParams['page'] = 0;
    setLazyParamsWorktypesTarget(_lazyParams);
  }
  const pagerWorktypesTarget = {
    layout: 'RowsPerPageDropdown CurrentPageReport PrevPageLink NextPageLink',
    'RowsPerPageDropdown': (options) => {
      const dropdownOptions = [
        {label: 10, value: 10},
        {label: 20, value: 20},
        {label: 50, value: 50},
        {label: 200, value: 200}
      ];

      return (
        <>
          {/*<span className="p-mx-1" style={{color: 'var(--text-color)', userSelect: 'none'}}>Tételek egy oldalon: </span>*/}
          <Dropdown value={options.value} options={dropdownOptions}
                    onChange={(e) => setRowsWorktypesTarget(e.target.value)}
                    appendTo={document.body}/>
        </>
      );
    },
    'CurrentPageReport': (options) => {
      return (
        <span style={{color: 'var(--text-color)', userSelect: 'none', width: '120px', textAlign: 'center'}}>
                        {options.first} - {options.last} / {options.totalRecords}
        </span>
      )
    }
  };
  const onWorktypesDelete = () => {
    let _worktypesToDelete = []
    Object.entries(worktypesToDelete).map(function (worktype, index) {
      _worktypesToDelete.push(worktype[1].id)
    })
    EntryzoneWorktypeRemoveService(_worktypesToDelete, formData.id)
      .then(response => {
        window.App.toastShow('success', 'Sikeres mentés!');
        loadLazyDataWorktypesSource(formData.id);
        loadLazyDataWorktypesTarget(formData.id);
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
      })
  }

  // entryLocation autocomplete
  const [entryLocations, setEntryLocations] = useState([]);
  const [selectedEntryLocation, setSelectedEntryLocation] = useState(localStorage.getItem('defaultProjectName'));

  const searchEntryLocation = (event) => {
    setSelectedEntryLocation(event.query.replace('Nincs találat', '').replace(': ', ''))
    EntrylocationListService(JSON.stringify({filters: {name: {value: event.query.replace('Nincs találat', '').replace(': ', '')}}}))
      .then(response => {
        if (response.data && response.data.items && response.data.items[0]) {
          setEntryLocations(response.data.items)
        } else {
          let string
          if (event.query) {
            string = 'Nincs találat: ' + event.query.replace('Nincs találat', '').replace(': ', '')
          } else {
            string = 'Nincs találat'
          }
          setSelectedEntryLocation(string)
        }
      })
      .catch(error => {
        window.App.toastShow('error', 'Hiba történt!', error.toString(), '', error.response);
      })
  }

  useEffect(() => {
    if (formData.id) {
      loadLazyDataWorktypesSource(formData.id)
      loadLazyDataWorktypesTarget(formData.id)
    }
    if (props && props.initialValues) {
      loadLazyDataWorktypesSource(props.initialValues.id)
      loadLazyDataWorktypesTarget(props.initialValues.id)
      setFormData(props.initialValues)
      setSelectedEntryLocation(props.initialValues.entryLocationName)
    }
  }, [lazyParamsWorktypesSource, lazyParamsWorktypesTarget])

  return (
    <Form onSubmit={onSubmit} initialValues={formData}
          validate={validate} render={({handleSubmit}) => (
      <form onSubmit={handleSubmit} className="">
        <div className={"p-grid p-d-flex p-flex-wrap"}>
          <div className={"p-col-12 p-lg-4 p-xl-4 p-d-flex"}>
            <Panel headerTemplate={
              <div className={"p-grid"}>
                <div className={"p-col-12"}>
                  <h3>
                    <i className={"pi pi-list"}></i> Alapadatok
                  </h3>
                </div>
              </div>
            } className={"w-100"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-md-6 p-lg-6"}>
                  <Field name="name" render={({input, meta}) => (
                    <div className="p-field p-fluid">
                      <label htmlFor="name"
                             className={classNames({'p-error': isFormFieldValid(meta)})}>Megnevezés</label>
                      <span className="p-input-icon-right">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                      {getFormErrorMessage(meta)}
                    </div>
                  )}/>
                </div>
                {/*<div className={"p-col-12 p-md-6 p-lg-6"}>*/}
                {/*  <Field name="entryLocation" render={({input, meta}) => (*/}
                {/*    <div className="p-field p-fluid">*/}
                {/*      <label htmlFor="entryLocation"*/}
                {/*             className={classNames({'p-error': isFormFieldValid(meta)})}>Projekt</label>*/}
                {/*      <span className="p-input-icon-right">*/}
                {/*        <AutoComplete value={selectedEntryLocation}*/}
                {/*                      id={"entryLocation"}*/}
                {/*                      suggestions={entryLocations}*/}
                {/*                      // forceSelection*/}
                {/*                      completeMethod={searchEntryLocation}*/}
                {/*                      field={"name"}*/}
                {/*                      delay="500"*/}
                {/*                      placeholder={"Keresés gépeléssel..."}*/}
                {/*                      className={classNames({'p-invalid': isFormFieldValid(meta)})}*/}
                {/*                      onSelect={(e) => {*/}
                {/*                        setFormData({*/}
                {/*                          ...formData,*/}
                {/*                          entryLocation: {id: e.value.id}*/}
                {/*                        })*/}
                {/*                        setSelectedEntryLocation(e.value.name)*/}
                {/*                        localStorage.setItem("defaultProjectId", e.value.id)*/}
                {/*                        localStorage.setItem("defaultProjectName", e.value.name)*/}
                {/*                      }}*/}
                {/*                      dropdown*/}
                {/*                      onClear={(e) => {*/}
                {/*                        setSelectedEntryLocation('')*/}
                {/*                      }}*/}
                {/*        />*/}
                {/*      </span>*/}
                {/*      {getFormErrorMessage(meta)}*/}
                {/*    </div>*/}
                {/*  )}/>*/}
                {/*</div>*/}
              </div>
              <div className={"p-grid p-mt-3"}>
                <div className={"p-col-12 p-lg-4 p-xl-4"}>

                </div>
                <div className={"p-col-12 p-lg-8 p-xl-8 p-text-right"}>
                  <Button type="submit" label="Mentés és bezár" icon={"pi pi-check"} loading={loading}
                          onClick={() => {
                            props = {...props, closeForm: true}
                          }}
                          className="p-button-success"/>
                  <Button type="submit" label="Mentés" icon={"pi pi-check"} loading={loading}
                          onClick={() => {
                            props = {...props, closeForm: false}
                          }}
                          className="p-button-success p-ml-2"/>
                </div>
              </div>
            </Panel>
          </div>
          <div className={"p-col-12 p-lg-8 p-xl-8 p-d-flex"}>
            <Panel className={"w-100"}>
              <div className={"p-grid"}>
                <div className={"p-col-12 p-lg-6 p-xl-6"}>
                  <div className={"p-grid"}>
                    <div className={"p-col-12"}>
                      <h3>
                        <i className={"pi pi-list"}></i> Kiválasztható munkatípusok
                      </h3>
                    </div>
                  </div>
                  {formData.id ? (
                    <>
                      <DataTable
                        emptyMessage="Nincs találat."
                        value={worktypesSource} paginator first={lazyParamsWorktypesSource.first}
                        totalRecords={totalRecordsWorktypesSource} onPage={onPageWorktypesSource}
                        onSort={onSortWorktypesSource} sortField={lazyParamsWorktypesSource.sortField}
                        sortOrder={lazyParamsWorktypesSource.sortOrder}
                        onFilter={onFilterWorktypesSource} filters={lazyParamsWorktypesSource.filters}
                        loading={loadingWorktypesSource} lazy
                        paginatorTemplate={pagerWorktypesSource} rows={rowsWorktypesSource}
                        emptyMessage="Nincs találat."
                        autoLayout={true}
                        selection={worktypesToAdd} onSelectionChange={e => {
                        setWorktypesToAdd(e.value)
                      }} dataKey="id"
                        selectionMode="checkbox"
                        filterDisplay="row"
responsiveLayout="scroll"
                        stripedRows
                      >
                        <Column selectionMode="multiple" headerStyle={{width: '3em'}}></Column>
                        <Column field="name" header="Név" sortable filter filterPlaceholder="Név"></Column>
                      </DataTable>
                      <div className={"p-grid p-mt-3"}>
                        <div className={"p-col-12 p-lg-6 p-xl-6"}>

                        </div>
                        <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right"}>
                          <Button type="button" label="Kijelöltek hozzáadása" icon={"pi pi-plus"}
                                  onClick={onWorktypesSubmit}
                                  className="p-button-success"/>
                        </div>
                      </div>
                    </>
                  ) : (
                    <><i className={"pi pi-lock"}></i> A munkatípusok kiválasztása csak mentés után lehetséges!</>
                  )}
                </div>
                <div className={"p-col-12 p-lg-6 p-xl-6"}>
                  <div className={"p-grid"}>
                    <div className={"p-col-12"}>
                      <h3>
                        <i className={"pi pi-list"}></i> Kiválasztott munkatípusok
                      </h3>
                    </div>
                  </div>
                  {formData.id ? (
                    <>
                      <DataTable
                        emptyMessage="Nincs találat."
                        value={worktypesTarget} paginator first={lazyParamsWorktypesTarget.first}
                        totalRecords={totalRecordsWorktypesTarget} onPage={onPageWorktypesTarget}
                        onSort={onSortWorktypesTarget} sortField={lazyParamsWorktypesTarget.sortField}
                        sortOrder={lazyParamsWorktypesTarget.sortOrder}
                        onFilter={onFilterWorktypesTarget} filters={lazyParamsWorktypesTarget.filters}
                        loading={loadingWorktypesTarget} lazy
                        paginatorTemplate={pagerWorktypesTarget} rows={rowsWorktypesTarget}
                        emptyMessage="Nincs találat."
                        autoLayout={true}
                        selection={worktypesToDelete} onSelectionChange={e => {
                        setWorktypesToDelete(e.value)
                      }} dataKey="id"
                        selectionMode="checkbox"
                        filterDisplay="row"
responsiveLayout="scroll"
                        stripedRows
                      >
                        <Column selectionMode="multiple" headerStyle={{width: '3em'}}></Column>
                        <Column field="name" header="Név" sortable filter filterPlaceholder="Név"></Column>
                      </DataTable>
                      <div className={"p-grid p-mt-3"}>
                        <div className={"p-col-12 p-lg-6 p-xl-6"}>

                        </div>
                        <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right"}>
                          <Button type="button" label="Kijelöltek törlése"
                                  icon="pi pi-trash"
                                  onClick={onWorktypesDelete}
                                  className="p-button-danger"/>
                        </div>
                      </div>
                    </>
                  ) : (
                    <><i className={"pi pi-lock"}></i> A munkatípusok megtekintése csak mentés után lehetséges!</>
                  )}
                </div>
              </div>
            </Panel>
          </div>
        </div>
      </form>
    )}/>
  )
}
export default withTranslation('common')(EntryzoneFormComponent);
